import React from 'react';
import PropTypes from 'prop-types';

import { EM_DASH } from '../../utils/constants';
import texts from '../../texts.json';

import { Eyebrow, MessageBody, MessageImage } from './styles';

const { details } = texts.history;

const MessagePanel = ({ bodyTemplate, image }) => (
  <>
    {image && <MessageImage src={image} alt={details.message.imageAlt} />}
    <Eyebrow>{details.message.label}</Eyebrow>
    <MessageBody>{bodyTemplate || EM_DASH}</MessageBody>
  </>
);

MessagePanel.propTypes = {
  bodyTemplate: PropTypes.string,
  image: PropTypes.string,
};

MessagePanel.defaultProps = {
  bodyTemplate: '',
  image: '',
};

export default MessagePanel;
